import {Injectable} from '@angular/core';
import {connectApi} from './connect-api';
import {HttpClient} from '@angular/common/http';
import {map} from 'rxjs/operators';
import {SESSION_STORAGE_KEYS} from './session-storage-keys';
import {forkJoin, Observable} from 'rxjs';
import {SharedDocumentsPackage} from './shared-documents-package';
import {UnityConnectTransaction} from './model/unity-connect-transaction';
import {LockScreenService} from './lock-screen.service';
import {Referral} from '../referral/referral';
import {CirfService} from '../cirf/cirf.service';
import {ReferralService} from '../referral/referral.service';
import {CustomHttpParams} from './connect-http-interceptor';
import {MatterInfo} from "./matter-info";
import {DocumentsPackageHistoryRecord} from './shared-documents-package-history';
import {DatePipe} from '@angular/common';
import { UnityConnectDocumentsTransaction } from './model/unity-connect-document-transaction';


@Injectable({
    providedIn: 'root'
})
export class DocumentsService {

    constructor(private http: HttpClient,
                private lockScreenService: LockScreenService,
                private cirfService: CirfService,
                public datePipe: DatePipe, // for mock only. Remove after backend implementation
                private referralService: ReferralService) {
    }

    getAllTransactionsForCurrentUser(): Observable<UnityConnectTransaction[]> {
        // this.lockScreenService.lockScreen = true;
        const result: UnityConnectTransaction[] = [];
        const transactionsRequest: any[] = [];
        transactionsRequest.push(this.cirfService.getCirfTransactionsForCurrentUser());
        transactionsRequest.push(this.getSharedDocPackageTransactionsForCurrentUser());
        transactionsRequest.push(this.referralService.getReferralTransactionsForCurrentUser());
        transactionsRequest.push(this.getParticipatingMatters());

        // this.lockScreenService.lockScreen = false;
        return forkJoin(transactionsRequest)
            .pipe(map( (res:any) => {
                if (Array.isArray(res)){
                    const transactionResult: UnityConnectTransaction[] = [];
                    if(res.length > 0) {
                        res[0].forEach( (t) => transactionResult.push(UnityConnectTransaction.fromCirf(t)));
                    }
                    if(res.length > 1) {
                        res[1].forEach( (t) => {
                            const sharedDocumentsPackage: SharedDocumentsPackage = new SharedDocumentsPackage(t);
                            if (sharedDocumentsPackage.documentsPackageHistoryRecords && sharedDocumentsPackage.documentsPackageHistoryRecords.length > 0) {
                                sharedDocumentsPackage.documentsPackageHistoryRecords.forEach((item: DocumentsPackageHistoryRecord) => {
                                    transactionResult.push(UnityConnectDocumentsTransaction.fromShared(sharedDocumentsPackage, item));
                                });
                            } else {
                                transactionResult.push(UnityConnectDocumentsTransaction.fromShared(sharedDocumentsPackage));
                            }
                        });
                    }
                    if(res.length > 2) {
                        res[2].forEach( (t) => transactionResult.push(UnityConnectTransaction.fromReferrals(new Referral(t))));
                    }
                    if(res.length > 3) {
                        res[3].forEach( (t) => transactionResult.push(UnityConnectTransaction.fromParticipatingMatter(new MatterInfo(t))));
                    }
                    return transactionResult;
                }
            }));
    }

    getSharedDocPackageTransactionsForCurrentUser(): Observable<SharedDocumentsPackage[]> {
        return this.http
            .get(connectApi.getSharedDocumentsPackagesForCurrentUser, {
                params: new CustomHttpParams(true)
            })
            .pipe(map(res => res['SharedDocuments']));
    }

    getParticipatingMatters(): Observable<MatterInfo []> {
        return this.http
            .get(connectApi.getParticipatingMatters, {
                params: new CustomHttpParams(true)
            })
            .pipe(map(res => res['ParticipatingMatters']));
    }

    openFile(documentId: number, guid: string) : void {
        const parsedUrl = new URL(window.location.href);
        let baseUrl = parsedUrl.origin;
        let api : string = connectApi.downloadDocument;
        let url = baseUrl+api.replace('{packageGuid}', '' + guid).replace('{documentId}', '' + documentId)+'?SessionId='+sessionStorage.getItem(SESSION_STORAGE_KEYS.sessionId);
        window.open(url,"_blank");
    }

    getSharedDocumentsPackage() : Observable<SharedDocumentsPackage> {
        const connectToken = sessionStorage.getItem(SESSION_STORAGE_KEYS.connectToken);
        return this.getSharedDocumentsPackageByGuid(connectToken);
    }

    getSharedDocumentsPackageByGuid(guid: string){
        return this.http.get(connectApi.sharedDocuments + guid, undefined)
            .pipe(map((res) => {
                return new SharedDocumentsPackage(res['SharedDocumentsPackage']);
            }));
    }

    getSharedDocPackageLogoFirm(id: string, fileId: number): string {
        return connectApi.getSharedDocPackageFirmLogo
            .replace('{packageGuid}', id)
            .replace('{fileId}', fileId.toString())
            .replace('{sessionId}', sessionStorage.getItem(SESSION_STORAGE_KEYS.sessionId));
    }

    getParticipatingMatterFirmLogo(matterId: string, fileId: number): string {
        return connectApi.getParticipatingMatterFirmLogo
            .replace('{matterId}', matterId)
            .replace('{fileId}', fileId.toString())
            .replace('{sessionId}', sessionStorage.getItem(SESSION_STORAGE_KEYS.sessionId));
    }

    updateSaredDocumentHistoryRecord (uct: UnityConnectTransaction): Observable<any> {
        if (uct && uct.guid && uct.historyRecord) {
            const url: string = connectApi.updateSharedDocumentsPackageHistory
                .replace('{packageGuid}', uct.guid)
                .replace('{historyId}', uct.historyRecord.identifier.toString());
            return this.http.put(url, uct.historyRecord).pipe(map(res => res));
        }
    }
}
